import { MessageType } from '@backend/domain'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class MessageResponse {
	@ApiProperty({ type: String })
	id: string

	@ApiProperty({ type: String })
	body: string

	@ApiProperty({ enum: MessageType })
	type: MessageType

	@ApiProperty({ type: Boolean })
	acknowledged: boolean
}

export class SendMessageRequest {
	@ApiProperty({ enum: MessageType })
	messageType: MessageType

	@ApiPropertyOptional({ type: String })
	message?: string

	@ApiPropertyOptional({ type: String })
	orderId?: string
}
